export type ChoirSetlistsGuideStepId = "create_setlist" | "create_rehearsal_from_setlist";

export interface ChoirSetlistsGuideState {
    completed: ChoirSetlistsGuideStepId[];
    dismissed_at: string | null;
    completed_at: string | null;
}

export const CHOIR_SETLISTS_GUIDE_STEPS: ChoirSetlistsGuideStepId[] = [
    "create_setlist",
    "create_rehearsal_from_setlist",
];

export function createDefaultChoirSetlistsGuideState(
    seed?: Partial<ChoirSetlistsGuideState> | null
): ChoirSetlistsGuideState {
    const completed = Array.isArray(seed?.completed)
        ? seed!.completed.filter((step): step is ChoirSetlistsGuideStepId => CHOIR_SETLISTS_GUIDE_STEPS.includes(step as ChoirSetlistsGuideStepId))
        : [];

    return {
        completed,
        dismissed_at: seed?.dismissed_at ?? null,
        completed_at: seed?.completed_at ?? null,
    };
}

export function getChoirSetlistsGuideNextStep(state: ChoirSetlistsGuideState): ChoirSetlistsGuideStepId | null {
    const completed = new Set(state.completed || []);
    return CHOIR_SETLISTS_GUIDE_STEPS.find((step) => !completed.has(step)) || null;
}

export function isChoirSetlistsGuideStepCompleted(
    state: ChoirSetlistsGuideState,
    step: ChoirSetlistsGuideStepId
): boolean {
    return state.completed.includes(step);
}

export function markChoirSetlistsGuideStep(
    state: ChoirSetlistsGuideState,
    step: ChoirSetlistsGuideStepId
): ChoirSetlistsGuideState {
    if (state.completed.includes(step)) {
        return state;
    }

    const nextCompleted = [...state.completed, step];
    const done = nextCompleted.length >= CHOIR_SETLISTS_GUIDE_STEPS.length;

    return {
        ...state,
        completed: nextCompleted,
        completed_at: done ? state.completed_at || new Date().toISOString() : state.completed_at,
    };
}
